import {
  FILTH_SEARCH_VISUALIZATION_FEATURE_ID,
  type FilthSearchVisualizationFeatureConfig,
  type PrismView,
} from "@/features/chat/components/prism-retrieval/prism-retrieval-constants"
import { resolvePrismView } from "@/features/chat/components/prism-retrieval/prism-retrieval-utils"
import { getFeatureConfig } from "@/hooks/feature-utils"
import { useConfigQuery } from "@/hooks/use-config-query"
import { useGeneralSettings } from "@/hooks/use-module-settings"

/**
 * The Prism retrieval view for the current user (#3261): their
 * `settings.prism_view` choice when it is a known view, else (unset,
 * "company" or an unknown value) the company default served on `/config` as
 * `filth_search_visualization.config.default_view`, else "levels".
 */
export function usePrismView(): PrismView {
  const { data: config } = useConfigQuery()
  const { settings } = useGeneralSettings()
  const companyDefault = getFeatureConfig<FilthSearchVisualizationFeatureConfig>(
    config?.features,
    FILTH_SEARCH_VISUALIZATION_FEATURE_ID
  )?.default_view
  return resolvePrismView(settings?.prism_view, companyDefault)
}
